import { Typography } from '@breetometer/components';
import { classNameMerger } from '@breetometer/utils';
import { capitalizeFirstLetter } from 'BreetHelpers';
import type { RefObject } from 'react';

import type { IDropDown } from '../../Dropdown.helpers';
import { DefaultDropDownControl } from '../controls/Default';
import { DefaultInputValue } from '../input-value/Default';
import { DefaultDropdownItems } from '../items/Default';
import { DropdownWrapper } from '../Wrapper';

const DefaultDropDown = ({
	handleItemSelect,
	selectedItem,
	items,
	iconAs,
	hideValue,
	placeholder,
	label,
	id,
	children,
	errorMessage,
	readOnly,
	readOnlySeparator,
	hideSearch,
	CustomItemOption,
	CustomItemSelectedProps,
	disabled,
	wrapperClassName,
	searchItemPlaceholder,
	disableReposition,
}: IDropDown) => (
	<div
		className={classNameMerger('dropdown', wrapperClassName)}
		data-testid='dropdown'
	>
		<DropdownWrapper disableReposition={disableReposition}>
			{(dropDownArgs) => {
				const { buttonRef, handleVisibility, visible, dropdownRef, controlRef, dropdownStyles } = dropDownArgs;

				return (
					<div className={classNameMerger('dropdowninput', !!disabled && 'disabled', 'bg-primary-500')}>
						<div
							className='dropdown_content'
							ref={controlRef as RefObject<HTMLDivElement>}
						>
							<DefaultDropDownControl
								selectedItem={selectedItem}
								buttonRef={buttonRef}
								handleVisibility={handleVisibility}
								visible={visible}
								iconAs={iconAs}
								CustomItemSelectedProps={CustomItemSelectedProps}
								isLabel={!!label}
								readOnly={readOnly}
								readOnlySeparator={readOnlySeparator}
								disabled={disabled}
							/>

							{!!label && (
								<label
									className='bt_label'
									htmlFor={id}
								>
									{label}
								</label>
							)}

							{children}

							{visible && (
								<DefaultDropdownItems
									handleItemSelect={handleItemSelect}
									dropDownRef={dropdownRef}
									hideSearch={hideSearch}
									inputValue={
										selectedItem?.value ? (
											<DefaultInputValue
												icon={selectedItem.icon as string}
												iconAs={iconAs}
												value={selectedItem.value}
											/>
										) : undefined
									}
									items={items}
									iconAs={iconAs}
									hideValue={hideValue}
									placeholder={placeholder}
									searchItemPlaceholder={searchItemPlaceholder}
									dropdownStyles={dropdownStyles}
									handleVisibility={handleVisibility}
									CustomItemOption={CustomItemOption}
								/>
							)}
						</div>
					</div>
				);
			}}
		</DropdownWrapper>
		{!!errorMessage && (
			<Typography
				as='p'
				className='dropdown_errormessage'
			>
				{capitalizeFirstLetter(errorMessage)}
			</Typography>
		)}
	</div>
);

export default DefaultDropDown;
